import PropTypes from 'prop-types';
import Tooltip from '../../../../components/Tooltip';
import { renderSeatNumber, renderPassengerFullName } from '../../../../../helpers/passenger-helper';
import { STATUS_TITLES, REFUSED } from '../Passenger/helper';
import * as Styled from './Style';
const OrderSegmentTicket = ({
  id,
  passenger,
  seatNumber,
  status,
  isLuggage,
  isMulti,
  index
}) => {
  const isRefundRefused = [REFUSED].includes(status);
  const renderTicketTitle = () => {
    if (isLuggage) {
      return I18n.t(`pages.account.order.luggage${isMulti ? '_many' : ''}`, {
        fio: renderPassengerFullName(passenger),
        count: index + 1
      });
    }
    return renderPassengerFullName(passenger);
  };
  return /*#__PURE__*/React.createElement(Styled.Item, null, /*#__PURE__*/React.createElement(Styled.Passenger, null, isLuggage ? /*#__PURE__*/React.createElement(Styled.LuggageIcon, null) : /*#__PURE__*/React.createElement(Styled.PassengerIcon, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Styled.PassengerName, null, renderTicketTitle()), /*#__PURE__*/React.createElement(Styled.PassengerDetails, null, /*#__PURE__*/React.createElement(Styled.TicketNumber, null, I18n.t('components.Order.ticket_number', {
    number: id
  })), /*#__PURE__*/React.createElement("span", null, renderSeatNumber(seatNumber))))), /*#__PURE__*/React.createElement(Styled.Status, null, /*#__PURE__*/React.createElement("span", null, STATUS_TITLES[status]), isRefundRefused && /*#__PURE__*/React.createElement(Tooltip, {
    className: "hyphens-break",
    content: I18n.t('components.Passenger.description_refused'),
    placement: "top"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon icon-info text-success pointer"
  }))));
};
OrderSegmentTicket.propTypes = {
  id: PropTypes.string.isRequired,
  seatNumber: PropTypes.string,
  status: PropTypes.string.isRequired,
  passenger: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    secondName: PropTypes.string
  }),
  isLuggage: PropTypes.bool,
  isMulti: PropTypes.bool,
  index: PropTypes.number
};
export default OrderSegmentTicket;